module.exports = __webpack_public_path__ + "img/61.1d27322b.jpg";